import Swiper, { Autoplay, Navigation, Pagination, EffectCube } from 'swiper';
Swiper.use([Navigation, Pagination, EffectCube, Autoplay]);

export default class {
  // Set inital vars
  constructor(el) {
    this.DOM = {}
    this.DOM.el = el
  }

  // Initilize Module
  init() {
    this.sliderBlog();
  }

  sliderBlog() {
    this.slider = new Swiper(this.DOM.el.querySelector('.swiper-container'), {
      slidesPerView: 1,
      effect: 'cube',
      loop: true,
      speed: 600,
      direction: 'horizontal',

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      mousewheel: {
        invert: true,
      },

    });
  }
}
